import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Container = styled.footer`
  background: #111;
  padding: 4rem 8% 2rem;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 2rem;

  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Logo = styled.a`
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  text-decoration: none;

  img {
    height: 32px;
    width: auto;
  }
`;

export const FooterDesc = styled.p`
  color: rgba(255, 255, 255, 0.38);
  font-size: 0.85rem;
  line-height: 1.65;
  max-width: 260px;
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 0.6rem;
  margin-top: 1rem;
`;

export const SocialLink = styled.a`
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.4);
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    background: rgba(253, 131, 96, 0.2);
    color: ${theme.colors.orange};
  }
`;

export const Col = styled.div`
  h4 {
    font-family: ${theme.fonts.display};
    font-weight: 700;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgba(255, 255, 255, 0.3);
    margin-bottom: 1.2rem;
  }

  a {
    display: block;
    color: rgba(255, 255, 255, 0.52);
    text-decoration: none;
    font-size: 0.86rem;
    margin-bottom: 0.65rem;
    transition: color 0.2s;
  }

  a:hover {
    color: ${theme.colors.orange};
  }
`;

export const Bottom = styled.div`
  background: #111;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  padding: 1.5rem 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.22);
  font-size: 0.78rem;
`;
